// import React, { useContext, useState } from "react";
// import { styled, useTheme } from "@mui/material/styles";
// import Box from "@mui/material/Box";
// import MuiDrawer from "@mui/material/Drawer";
// import List from "@mui/material/List";
// import IconButton from "@mui/material/IconButton";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import ListItemText from "@mui/material/ListItemText";
// import HomeTwoToneIcon from "@mui/icons-material/HomeTwoTone";
// import AddModeratorTwoToneIcon from "@mui/icons-material/AddModeratorTwoTone";
// import KeyboardDoubleArrowRightSharpIcon from "@mui/icons-material/KeyboardDoubleArrowRightSharp";
// import KeyboardDoubleArrowLeftSharpIcon from "@mui/icons-material/KeyboardDoubleArrowLeftSharp";
// import PersonOutlineTwoToneIcon from "@mui/icons-material/PersonOutlineTwoTone";
// import SettingsTwoToneIcon from "@mui/icons-material/SettingsTwoTone";
// import SupervisorAccountTwoToneIcon from '@mui/icons-material/SupervisorAccountTwoTone';
// import { Collapse, Tooltip, Stack } from "@mui/material";
// import Toolbar from "@mui/material/Toolbar";
// import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
// import ExitToAppIcon from "@mui/icons-material/ExitToApp";
// import MuiAppBar from "@mui/material/AppBar";
// import { tooltipClasses } from "@mui/material/Tooltip";
// import Card from "@mui/material/Card";
// import CardContent from "@mui/material/CardContent";
// import CardActionArea from "@mui/material/CardActionArea";
// import { LoginContext } from "../../../contexts/loginContext";
// import { CapitalizeName } from "../../../utils/capitalizeName";
// import { useNavigate } from "react-router-dom";
// import LogoutIcon from "@mui/icons-material/Logout";
// import AdminDashboard from "../AdminDashboard";
// import UserSubscribers from "../UserSubscribers";
// import SubscribeDetail from "../SubscribeDetail";
// import SubscriptionPlan from "../SubscriptionPlan";
// import { Link } from "react-router-dom";
// import SectorManagement from "../SectorManagement";
// import SampleDashboard from "../../../components/SampleDashboard";
// import MockDash from "../AdminDashboard/MockDash";
// import { useDispatch, useSelector } from "react-redux";
// import { logout } from "../../../Redux/slices/authSlice";
// import SDCManagement from "../SDCManagement";
// import DepartmentManagement from "../DepartmentManagement";
// import UserManagement from "../UserManagement";
// import AddOrganization from "../AddOrganization";
// import ListOrganization from "../ListOrganization";
// import RoleManagement from "../RoleManagement";
// import SkillManagement from "../SkillManagement";
// import PageRightsAccess from "../PageRightAccess";
// import TP_interviewermgmt from "../TP_Interviewer";

// const drawerWidth = 300;

// const openedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
//   borderTopRightRadius: 30,
//   borderBottomRightRadius: 30,
//   backgroundColor: "#006A71",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
//   borderTopRightRadius: 30,
//   borderBottomRightRadius: 30,
//   backgroundColor: "#006A71",
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   backgroundColor: "#1E1E1E",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": openedMixin(theme),
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": closedMixin(theme),
//   }),
// }));
// const AppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   borderRadius: 10,
//   backgroundColor: "#1E1E1E",
//   marginTop: 15,
//   marginRight: 20,
//   width: `calc(100% - 7%)`,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     width: `calc(100% - ${drawerWidth + 40}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));
// const LightTooltip = styled(({ className, ...props }) => (
//   <Tooltip {...props} classes={{ popper: className }} />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.common.white,
//     color: "rgba(0, 0, 0, 0.87)",
//     boxShadow: theme.shadows[1],
//     fontSize: 11,
//   },
// }));

// const AdminLandingPage = ({ title }) => {
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const [menudata, setMenudata] = useState("Dashboard");
//   const [titleText, setTitleText] = useState("System Admin Dashboard");
//   const dispatch = useDispatch();
//   const userName = CapitalizeName(user?.name || "");
//   const navigate = useNavigate();
//   const [editOrgData, setEditOrgData] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [showAddOrganization, setShowAddOrganization] = useState(false);
//   const [showSubscriptionPlan, setShowSubscriptionPlan] = useState(false);

//   const icons = [
//     HomeTwoToneIcon,
//     AddModeratorTwoToneIcon,
//     PersonOutlineTwoToneIcon,
//     SettingsTwoToneIcon,
//     SupervisorAccountTwoToneIcon,
//   ];

//   const handleListItemClick = (item) => {
//     setMenudata(item);
//     setTitleText(item);
//     setShowAddOrganization(false);
//     setShowSubscriptionPlan(false);
//   };

//   const handleDrawerToggle = () => {
//     setOpen(!open);
//   };

//   const handleOpenAddOrganization = () => {
//     setMenudata("");
//     setTitleText("Add Organization");
//     setShowAddOrganization(true);
//     setEditOrgData(null);
//   };

//   const handleOpenEditOrganization = (orgData) => {
//     setMenudata("");
//     setTitleText("Edit Organization");
//     setShowAddOrganization(true);
//     setEditOrgData(orgData);
//   };

//   const handleOpenSubscriptionPlan = () => {
//     setMenudata("");
//     setShowSubscriptionPlan(true);
//   };

//   const handleLogOut = () => {
//     localStorage.clear();
//     sessionStorage.clear();
//     dispatch(logout());
//     setTimeout(() => navigate("/"), 0);
//   };

//   if (!isAuthenticated || user?.role !== "Admin") {
//     return null;
//   }

//   const adminMasterOptions = [
//     "Department Management",
//     "Area Management",
//     "Sector Management",
//     "Role Management",
//     "Skill Management",
//   ];

//   const organizationOptions = ["Add Organization", "List Organization"];

//   return (
//     <Box sx={{ display: "flex", backgroundColor: "white", height: "100vh" }}>
//       <AppBar position="fixed" open={open} sx={{ background: "#006A71" }}>
//         <Toolbar>
//           <Box sx={{ flexGrow: 1 }}>
//             <Typography
//               variant="h5"
//               color="white"
//               sx={{ fontSize: "25px", textAlign: "left" }}
//             >
//               {titleText}
//             </Typography>
//           </Box>
//           <Button
//             sx={{
//               display: { xs: "none", sm: "flex" },
//               border: "1px solid #00BFFF",
//               color: "white",
//               height: "45px",
//               width: "148px",
//               borderRadius: "10px",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "15px",
//               backgroundColor: "#273480",
//             }}
//           >
//             <ExitToAppIcon />
//             Export
//           </Button>
//         </Toolbar>
//       </AppBar>
//       <Drawer variant="permanent" open={open}>
//         <DrawerHeader sx={{ position: "relative" }}>
//           <Box
//             sx={{
//               backgroundColor: "white",
//               width: "100%",
//               height: "100%",
//               marginTop: "5%",
//               marginRight: "30px",
//               borderRadius: "10px 30px 0px 20px",
//             }}
//           >
//             {isAuthenticated && open && (
//               <LightTooltip title={`${user?.name || ""}`} placement="right">
//                 <Typography
//                   sx={{
//                  position: "absolute",
//       top: "20px",
//       left: "45%",
//       transform: "translateX(-50%)", // ✅ perfect centering
//       fontSize: "15px",
//       fontWeight: "bold",
//       color: "#1E1E1E",
//       maxWidth: "250px",
//       textAlign: "center",
//       wordBreak: "break-word",
//       lineHeight: "1.2",
//     }}
//   >
//     Welcome 
//     {userName?.length > 12 ? <br /> :" "}
//     {userName}
//                 </Typography>
//               </LightTooltip>
//             )}
//           </Box>
//         </DrawerHeader>
//         <DrawerHeader>
//           <IconButton
//             color="white"
//             aria-label="open drawer"
//             onClick={handleDrawerToggle}
//             edge="start"
//             sx={{ color: "white", marginRight: 1, marginLeft: 1 }}
//           >
//             {open ? (
//               <KeyboardDoubleArrowLeftSharpIcon />
//             ) : (
//               <KeyboardDoubleArrowRightSharpIcon />
//             )}
//           </IconButton>
//         </DrawerHeader>
//         <List sx={{ color: "white" }}>
//           {[
//             "Dashboard",
//             "Admin Master",
//             "User Management",
//             "Organization Management",
//             "TP_Interviewer Management"
//           ].map((text, index) => (
//             <ListItem
//               key={text}
//               disablePadding
//               onClick={() => handleListItemClick(text)}
//             >
//               <ListItemButton>
//                 <ListItemIcon sx={{ color: "white" }}>
//                   <LightTooltip title={text}>
//                     {React.createElement(icons[index % icons.length])}
//                   </LightTooltip>
//                 </ListItemIcon>
//                 <ListItemText primary={text} />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>
//         <DrawerHeader>
//           <IconButton
//             color="inherit"
//             aria-label="open drawer"
//             onClick={handleDrawerToggle}
//             edge="start"
//             sx={{ color: "white", marginRight: 1 }}
//           >
//             <Stack direction="column" spacing={1}>
//               {open ? (
//                 <KeyboardDoubleArrowLeftSharpIcon />
//               ) : (
//                 <KeyboardDoubleArrowRightSharpIcon />
//               )}
//               {isAuthenticated && (
//                 <div onClick={handleLogOut} title="Logout">
//                   <LogoutIcon />
//                 </div>
//               )}
//             </Stack>
//           </IconButton>
//         </DrawerHeader>
//       </Drawer>
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           minHeight: "100vh",
//           backgroundColor: "white",
//           overflow: "auto",
//         }}
//       >
//         <DrawerHeader />
//         {menudata === "Dashboard" && <MockDash />}
//         {menudata === "Admin Master" && (
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
//               gap: 4,
//               mt: 8,
//               mx: 7,
//             }}
//           >
//             {adminMasterOptions.map((option) => (
//               <Card
//                 key={option}
//                 sx={{ maxWidth: 250, bgcolor: "#006A71", minHeight: 100 }}
//               >
//                 <CardActionArea onClick={() => handleListItemClick(option)}>
//                   <CardContent>
//                     <Typography variant="h6" component="div">
//                       {option}
//                     </Typography>
//                   </CardContent>
//                 </CardActionArea>
//               </Card>
//             ))}
//           </Box>
//         )}
//         {menudata === "Organization Management" && (
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
//               gap: 4,
//               mt: 8,
//               mx: 7,
//             }}
//           >
//             {organizationOptions.map((option) => (
//               <Card
//                 key={option}
//                 sx={{ maxWidth: 250, bgcolor: "#006A71", minHeight: 100 }}
//               >
//                 <CardActionArea onClick={() => handleListItemClick(option)}>
//                   <CardContent>
//                     <Typography variant="h6" component="div">
//                       {option}
//                     </Typography>
//                   </CardContent>
//                 </CardActionArea>
//               </Card>
//             ))}
//           </Box>
//         )}
//         {menudata === "TP_Interviewer Management" && <TP_interviewermgmt/>}
//         {menudata === "Area Management" && <SDCManagement />}
//         {menudata === "Department Management" && <DepartmentManagement />}
//         {menudata === "Sector Management" && <SectorManagement />}
//         {menudata === "Role Management" && <RoleManagement />}
//         {menudata === "Skill Management" && <SkillManagement />}
//         {menudata === "User Management" && <UserManagement />}
//         {menudata === "Page access rights" && <PageRightsAccess />}
//         {menudata === "UserSubscribers" && <UserSubscribers />}
//         {menudata === "Add Organization" && <AddOrganization />}
//         {menudata === "Subscribe Detail" && (
//           <SubscribeDetail
//             onOpenSubscriptionPlan={handleOpenSubscriptionPlan}
//           />
//         )}
//         {showSubscriptionPlan && <SubscriptionPlan />}
//         {menudata === "List Organization" && (
//           <ListOrganization
//             onOpenAddOrganization={handleOpenAddOrganization}
//             onOpenEditOrganization={handleOpenEditOrganization}
//           />
//         )}
//         {showAddOrganization && <AddOrganization orgData={editOrgData} />}
//       </Box>
//     </Box>
//   );
// };

// export default AdminLandingPage;



































// import React, { useState } from "react";
// import { styled, useTheme } from "@mui/material/styles";
// import {
//   Box,
//   Drawer as MuiDrawer,
//   AppBar as MuiAppBar,
//   Toolbar,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   IconButton,
//   Typography,
//   Button,
//   Card,
//   CardActionArea,
//   CardContent,
//   Stack,
//   Tooltip,
//   Avatar,
//   Menu,
//   MenuItem,
//   Divider,
//   Chip,
// } from "@mui/material";
// import {
//   Menu as MenuIcon,
//   ChevronRight as ChevronRightIcon,
//   ChevronLeft as ChevronLeftIcon,
//   Home as HomeIcon,
//   Settings as SettingsIcon,
//   People as PeopleIcon,
//   Business as BusinessIcon,
//   VideoCall as VideoCallIcon,
//   Logout as LogoutIcon,
//   ExpandMore as ExpandMoreIcon,
//   Fullscreen as FullscreenIcon,
//   ArrowBack as ArrowBackIcon,
// } from "@mui/icons-material";
// import DarkModeIcon from "@mui/icons-material/DarkMode";
// import LightModeIcon from "@mui/icons-material/LightMode";
// // import COLORS from "../../Themes/Colours"
// import { useThemeMode } from "../../Themes/ThemeContextTemp";
// import { useDispatch, useSelector } from "react-redux";
// import { logout } from "../../../Redux/slices/authSlice";
// import { useNavigate } from "react-router-dom";
// import { CapitalizeName } from "../../../utils/capitalizeName";
// import department from '../../../card icons/department.png'
// import area from '../../../card icons/area.png'
// import sector from '../../../card icons/sector.png'
// import role from '../../../card icons/role.png'
// import skill from '../../../card icons/skill.png'
// import add from '../../../card icons/add.png'
// import list from '../../../card icons/list.png'
// // Components
// import AdminDashboard from "../AdminDashboard";
// import UserSubscribers from "../UserSubscribers";
// import SubscribeDetail from "../SubscribeDetail";
// import SubscriptionPlan from "../SubscriptionPlan";
// import SectorManagement from "../SectorManagement";
// import MockDash from "../AdminDashboard/MockDash";
// import SDCManagement from "../SDCManagement";
// import DepartmentManagement from "../DepartmentManagement";
// import UserManagement from "../UserManagement";
// import AddOrganization from "../AddOrganization";
// import ListOrganization from "../ListOrganization";
// import RoleManagement from "../RoleManagement";
// import SkillManagement from "../SkillManagement";
// import PageRightsAccess from "../PageRightAccess";
// import TP_interviewermgmt from "../TP_Interviewer";


// const drawerWidth = 300;

// // ==================== STYLED COMPONENTS ====================
// const openedMixin = (theme) => ({
//   width: drawerWidth,
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen,
//   }),
//   overflowX: "hidden",
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   overflowX: "hidden",
//   width: `calc(${theme.spacing(7)} + 1px)`,
//   [theme.breakpoints.up("sm")]: {
//     width: `calc(${theme.spacing(8)} + 1px)`,
//   },
// });

// const DrawerHeader = styled("div")(({ theme }) => ({
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "flex-end",
//   padding: theme.spacing(0, 1),
//   ...theme.mixins.toolbar,
// }));

// const StyledDrawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   width: drawerWidth,
//   flexShrink: 0,
//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   ...(open && {
//     ...openedMixin(theme),
//     "& .MuiDrawer-paper": {
//       ...openedMixin(theme),
//       background: COLORS.secondary,
//       borderRight: `1px solid ${COLORS.border}`,
//     },
//   }),
//   ...(!open && {
//     ...closedMixin(theme),
//     "& .MuiDrawer-paper": {
//       ...closedMixin(theme),
//       background: COLORS.secondary,
//       borderRight: `1px solid ${COLORS.border}`,
//     },
//   }),
// }));

// const StyledAppBar = styled(MuiAppBar, {
//   shouldForwardProp: (prop) => prop !== "open",
// })(({ theme, open }) => ({
//   background: COLORS.primary,
//   borderBottom: `1px solid ${COLORS.border}`,
//   zIndex: theme.zIndex.drawer + 1,
//   transition: theme.transitions.create(["width", "margin"], {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen,
//   }),
//   ...(open && {
//     marginLeft: drawerWidth,
//     width: `calc(100% - ${drawerWidth}px)`,
//     transition: theme.transitions.create(["width", "margin"], {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   }),
// }));

// const AdminCard = styled(Card)({
//   background: COLORS.cardBg,
//   border: `1px solid ${COLORS.cardBorder}`,
//   borderRadius: "12px",
//   transition: "all 0.3s ease",
//   "&:hover": {
//     background: COLORS.cardBg,
//     border: `1px solid ${COLORS.accent}`,
//     boxShadow: `0 8px 16px rgba(233, 69, 96, 0.15)`,
//     transform: "translateY(-2px)",
//   },
//   minHeight: 120,
//   display: "flex",
//   flexDirection: "column",
//   justifyContent: "center",
// });

// // ==================== MAIN COMPONENT ====================
// const AdminLandingPage = ({ title }) => {
//   const { isAuthenticated, user } = useSelector((state) => state.auth);
//   const [menudata, setMenudata] = useState("Dashboard");
//   const [titleText, setTitleText] = useState("Admin Dashboard");
//   const [open, setOpen] = useState(true);
//   const [editOrgData, setEditOrgData] = useState(null);
//   const [showAddOrganization, setShowAddOrganization] = useState(false);
//   const [showSubscriptionPlan, setShowSubscriptionPlan] = useState(false);
//   const [profileAnchor, setProfileAnchor] = useState(null);
//   const [selectedAdminMaster, setSelectedAdminMaster] = useState(null);
//   const [showOrgManagementCards, setShowOrgManagementCards] = useState(true);
//   const { COLORS, theme, toggleTheme } = useThemeMode();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const userName = CapitalizeName(user?.name || "");

//   const ADMIN_MASTER_CONFIG = [
//     {
//       title: "Department Management",
//       image: department,
//       subtitle: "Organization Structure",
//       key: "Department Management",
//       badge: "Admin",
//       tag: "Configuration",
//     },
//     {
//       title: "Area Management",
//       image: area,
//       subtitle: "Geographical Areas",
//       key: "Area Management",
//       badge: "Admin",
//       tag: "Location",
//     },
//     {
//       title: "Sector Management",
//       image: sector,
//       subtitle: "Business Sectors",
//       key: "Sector Management",
//       badge: "Admin",
//       tag: "Business",
//     },
//     {
//       title: "Role Management",
//       image: role,
//       subtitle: "Access & Permissions",
//       key: "Role Management",
//       badge: "Admin",
//       tag: "Access",

//     },
//     {
//       title: "Skill Management",
//       image: skill,
//       subtitle: "Employee Skills",
//       key: "Skill Management",
//       badge: "Admin",
//       tag: "HR",
//     },
//   ];

//   const organizationOptions = [

//     { title: "Add Organization",
//       key: "Add Organization",
//       image: add,
//       subtitle: "Register New Organization",
//       badge: "Organization",
//       tag: "Client",

//      },
//     { title: "List Organization",
//       key: "List Organization",
//       image: list,
//       subtitle: "View Organization",
//       badge: "Organization",
//       tag: "Client", },
//   ];

//   const menuItems = [
//     {
//       label: "Dashboard",
//       icon: HomeIcon,
//       key: "Dashboard",
//     },
//     {
//       label: "Admin Master",
//       icon: SettingsIcon,
//       key: "Admin Master",
//     },
//     {
//       label: "User Management",
//       icon: PeopleIcon,
//       key: "User Management",
//     },
//     {
//       label: "Organization Management",
//       icon: BusinessIcon,
//       key: "Organization Management",
//     },
//     {
//       label: "Third Party Interviewers",
//       icon: PeopleIcon,
//       key: "Third Party Interviewers",
//     },
//   ];

//   const handleDrawerToggle = () => {
//     setOpen(!open);
//   };

//   const handleListItemClick = (item) => {
//     setMenudata(item);
//     setTitleText(item);
//     setShowAddOrganization(false);
//     setShowSubscriptionPlan(false);
//     setSelectedAdminMaster(null);
//     setShowOrgManagementCards(true);
//   };

//   // Handle Admin Master Card Click
//   const handleAdminMasterCardClick = (masterKey, masterTitle) => {
//     setSelectedAdminMaster(masterKey);
//     setMenudata(masterKey);
//     setTitleText(masterTitle);
//   };

//   // Handle back button for Admin Master
//   const handleBackFromAdminMaster = () => {
//     setSelectedAdminMaster(null);
//     setMenudata("Admin Master");
//     setTitleText("Admin Master");
//   };

//   // Handle Organization Management Card Click
//   const handleOrgManagementCardClick = (option) => {
//     setShowOrgManagementCards(false);
//     setMenudata(option);
//     setTitleText(option);
//   };

//   // Handle back button for Organization Management
//   const handleBackFromOrgManagement = () => {
//     setShowOrgManagementCards(true);
//     setMenudata("Organization Management");
//     setTitleText("Organization Management");
//   };

//   const handleOpenAddOrganization = () => {
//     setMenudata("");
//     setTitleText("Add Organization");
//     setShowAddOrganization(true);
//     setEditOrgData(null);
//   };

//   const handleOpenEditOrganization = (orgData) => {
//     setMenudata("");
//     setTitleText("Edit Organization");
//     setShowAddOrganization(true);
//     setEditOrgData(orgData);
//   };

//   const handleOpenSubscriptionPlan = () => {
//     setMenudata("");
//     setShowSubscriptionPlan(true);
//   };

//   const handleProfileMenuOpen = (event) => {
//     setProfileAnchor(event.currentTarget);
//   };

//   const handleProfileMenuClose = () => {
//     setProfileAnchor(null);
//   };

//   const handleLogOut = () => {
//     handleProfileMenuClose();
//     localStorage.clear();
//     sessionStorage.clear();
//     dispatch(logout());
//     setTimeout(() => navigate("/"), 0);
//   };

//   if (!isAuthenticated || user?.role !== "Admin") {
//     return null;
//   }

//   const handleFullscreen = () => {
//     if (
//       document.fullscreenElement ||
//       document.webkitFullscreenElement ||
//       document.msFullscreenElement
//     ) {
//       if (document.exitFullscreen) {
//         document.exitFullscreen();
//       } else if (document.webkitExitFullscreen) {
//         document.webkitExitFullscreen();
//       } else if (document.msExitFullscreen) {
//         document.msExitFullscreen();
//       }
//     } else {
//       const element = document.documentElement;
//       if (element.requestFullscreen) {
//         element.requestFullscreen();
//       } else if (element.webkitRequestFullscreen) {
//         element.webkitRequestFullscreen();
//       } else if (element.msRequestFullscreen) {
//         element.msRequestFullscreen();
//       }
//     }
//   };

//   return (
//     <Box sx={{ display: "flex", background: COLORS.background, minHeight: "100vh" }}>
//       {/* AppBar */}
//       <StyledAppBar position="fixed" open={open}>
//         <Toolbar sx={{ minHeight: "70px", display: "flex", justifyContent: "space-between" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <IconButton
//               color="inherit"
//               aria-label="toggle drawer"
//               onClick={handleDrawerToggle}
//               edge="start"
//               sx={{ color: COLORS.accent }}
//             >
//               {open ? <ChevronLeftIcon /> : <MenuIcon />}
//             </IconButton>

//             {/* Back Button for Admin Master */}
//             {selectedAdminMaster && (
//               <IconButton
//                 onClick={handleBackFromAdminMaster}
//                 sx={{ color: COLORS.accent, mr: 1 }}
//                 title="Go back"
//               >
//                 <ArrowBackIcon />
//               </IconButton>
//             )}

//             {/* Back Button for Organization Management */}
//             {menudata === "Organization Management" && !showOrgManagementCards && (
//               <IconButton
//                 onClick={handleBackFromOrgManagement}
//                 sx={{ color: COLORS.accent, mr: 1 }}
//                 title="Go back"
//               >
//                 <ArrowBackIcon />
//               </IconButton>
//             )}

//             <Typography
//               variant="h6"
//               noWrap
//               component="div"
//               sx={{
//                 fontSize: "20px",
//                 fontWeight: 600,
//                 color: COLORS.text,
//                 letterSpacing: "0.5px",
//               }}
//             >
//               {titleText}
//             </Typography>
//           </Box>

//           {/* Right Side Actions */}
//           <Stack direction="row" spacing={2} sx={{ display: "flex", alignItems: "center" }}>
            
            
            
            
//             <Toolbar sx={{ justifyContent: "flex-end" }}>
//           <IconButton
//             onClick={toggleTheme}
//             sx={{
//               color: COLORS.textPrimary,
//             }}
//           >
//             {theme === "light" ? (
//               <DarkModeIcon />
//             ) : (
//               <LightModeIcon />
//             )}
//           </IconButton>
//         </Toolbar>
            
            
            
            
            
            
            
            
            
//             <Tooltip title="Fullscreen Mode (F11)">
//               <IconButton
//                 onClick={handleFullscreen}
//                 sx={{
//                   color: COLORS.text,
//                   "&:hover": { background: COLORS.hoverBg },
//                 }}
//               >
//                 <FullscreenIcon />
//               </IconButton>
//             </Tooltip>

//             <Button
//               onClick={handleProfileMenuOpen}
//               sx={{
//                 display: { xs: "none", sm: "flex" },
//                 alignItems: "center",
//                 gap: 1,
//                 color: COLORS.text,
//                 textTransform: "none",
//                 fontSize: "14px",
//                 padding: "6px 12px",
//                 borderRadius: "6px",
//                 "&:hover": { background: COLORS.hoverBg },
//               }}
//             >
//               <Avatar
//                 sx={{
//                   width: 32,
//                   height: 32,
//                   background: COLORS.accent,
//                   fontSize: "14px",
//                   fontWeight: 700,
//                 }}
//               >
//                 {userName.charAt(0).toUpperCase()}
//               </Avatar>
//               <Typography sx={{ fontSize: "13px" }}>{userName.split(" ")[0]}</Typography>
//               <ExpandMoreIcon sx={{ fontSize: "18px" }} />
//             </Button>

//             {/* Profile Menu */}
//             <Menu
//               anchorEl={profileAnchor}
//               open={Boolean(profileAnchor)}
//               onClose={handleProfileMenuClose}
//               anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
//               transformOrigin={{ vertical: "top", horizontal: "right" }}
//               PaperProps={{
//                 sx: {
//                   background: COLORS.primary,
//                   border: `1px solid ${COLORS.border}`,
//                   borderRadius: "8px",
//                   mt: 1,
//                 },
//               }}
//             >
//               <MenuItem
//                 sx={{
//                   color: COLORS.text,
//                   padding: "12px 20px",
//                   "&:hover": { background: COLORS.hoverBg },
//                 }}
//               >
//                 <Avatar
//                   sx={{
//                     width: 28,
//                     height: 28,
//                     background: COLORS.accent,
//                     mr: 1.5,
//                     fontSize: "12px",
//                   }}
//                 >
//                   {userName.charAt(0).toUpperCase()}
//                 </Avatar>
//                 {userName}
//               </MenuItem>

//               <MenuItem
//                 sx={{
//                   color: COLORS.textSecondary,
//                   fontSize: "12px",
//                   padding: "4px 20px",
//                   "&:hover": { background: "transparent" },
//                 }}
//               >
//                 {user?.role}
//               </MenuItem>

//               <Divider sx={{ borderColor: COLORS.border, my: 1 }} />

//               <MenuItem
//                 onClick={handleLogOut}
//                 sx={{
//                   color: COLORS.accent,
//                   padding: "12px 20px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 1,
//                   "&:hover": { background: COLORS.hoverBg },
//                 }}
//               >
//                 <LogoutIcon sx={{ fontSize: "18px" }} />
//                 Logout
//               </MenuItem>
//             </Menu>
//           </Stack>
//         </Toolbar>
//       </StyledAppBar>

//       {/* Drawer */}
//       <StyledDrawer variant="permanent" open={open}>
//         <DrawerHeader sx={{ minHeight: "70px", borderBottom: `1px solid ${COLORS.border}` }}>
//           {open && (
//             <Box sx={{ pr: 2, width: "100%" }}>
//               <Typography
//                 sx={{
//                   fontSize: "11px",
//                   fontWeight: 700,
//                   color: COLORS.accent,
//                   textTransform: "uppercase",
//                   letterSpacing: "1.5px",
//                   mb: 1,
//                 }}
//               >
//                 Navigation
//               </Typography>
//             </Box>
//           )}
//         </DrawerHeader>

//         {/* Navigation List */}
//         <List sx={{ color: COLORS.text, flex: 1 }}>
//           {menuItems.map((item) => (
//             <ListItem key={item.key} disablePadding>
//               <ListItemButton
//                 onClick={() => handleListItemClick(item.key)}
//                 sx={{
//                   minHeight: 48,
//                   justifyContent: open ? "initial" : "center",
//                   px: 2.5,
//                   "&:hover": {
//                     background: COLORS.hoverBg,
//                     color: COLORS.accent,
//                   },
//                   color: menudata === item.key && !selectedAdminMaster && !showOrgManagementCards === false ? COLORS.accent : COLORS.text,
//                 }}
//               >
//                 <ListItemIcon
//                   sx={{
//                     minWidth: 0,
//                     mr: open ? 3 : "auto",
//                     justifyContent: "center",
//                     color: "inherit",
//                   }}
//                 >
//                   <item.icon sx={{ fontSize: "22px" }} />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary={item.label}
//                   sx={{
//                     opacity: open ? 1 : 0,
//                     fontSize: "14px",
//                     "& .MuiTypography-root": {
//                       fontSize: "14px",
//                       fontWeight: menudata === item.key && !selectedAdminMaster ? 600 : 500,
//                     },
//                   }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>

//         {/* Bottom Divider */}
//         <Divider sx={{ borderColor: COLORS.border }} />

//         {/* Bottom Actions */}
//         {open && (
//           <Box
//             sx={{
//               p: 2,
//               display: "flex",
//               flexDirection: "column",
//               gap: 1,
//             }}
//           >
//             <Button
//               onClick={handleLogOut}
//               fullWidth
//               sx={{
//                 color: COLORS.accent,
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 justifyContent: "flex-start",
//                 textTransform: "none",
//                 fontSize: "14px",
//                 padding: "10px 12px",
//                 borderRadius: "6px",
//                 border: `1px solid ${COLORS.border}`,
//                 "&:hover": {
//                   background: COLORS.hoverBg,
//                   borderColor: COLORS.accent,
//                 },
//               }}
//             >
//               <LogoutIcon sx={{ fontSize: "18px" }} />
//               Logout
//             </Button>
//           </Box>
//         )}
//       </StyledDrawer>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           minHeight: "100vh",
//           background: COLORS.background,
//           overflow: "auto",
//         }}
//       >
//         {/* Dashboard */}
//         {menudata === "Dashboard" && <MockDash />}

//         {/* Admin Master Cards Grid */}
//         {menudata === "Admin Master" && !selectedAdminMaster && (
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
//               gap: 3,
//               mt: 2,
//             }}
//           >
//             {ADMIN_MASTER_CONFIG.map((option) => (
            
//              <Card
//                   onClick={() => handleAdminMasterCardClick(option.key, option.title)}
//                   sx={{
//                     minWidth: { xs: 260, sm: 300 },
//                     borderRadius: "10px",
//                     border: "1px solid #e5e7eb",
//                     boxShadow:
//                       "0 10px 20px rgba(0,0,0,0.08)",
//                     cursor: "pointer",
//                     transition: "all 0.25s ease",
//                     "&:hover": {
//                       transform: "translateY(-4px)",
//                       boxShadow: "0 16px 30px rgba(0,0,0,0.12)",
//                     },
//                   }}
//                 >
//                   {/* Image Section */}
//                   <Box p={1.5}>
//                     <Box
//                       sx={{
//                         borderRadius: "8px",
//                         bgcolor: "#f5f5f5",
//                         overflow: "hidden",
//                         height: 180,
//                         display: "flex",
//                         alignItems: "center",
//                        justifyContent: "center",
//                       }}
//                     >
//                       <Box
//                         component="img"
//                         src={option.image}
//                         alt={title}
//                         sx={{
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "contain",
//                         }}
//                      />
//                     </Box>
//                   </Box>
            
//                   {/* Content */}
//                   <Box px={1.5} pb={2}>
//                     {/* Badges */}
//                     <Box display="flex" gap={1} flexWrap="wrap">
//                       {option.badge && (
//                         <Chip
//                           label={option.badge}
//                           size="small"
//                           sx={{
//                             bgcolor: "#e11d48",
//                             color: "#fff",
//                             fontWeight: 600,
//                            fontSize: "12px",
//                          }}
//                        />
//                       )}
            
//                       {option.tag && (
//                         <Chip
//                          label={option.tag}
//                           size="small"
//                          sx={{
//                            bgcolor: "rgba(0,0,0,0.06)",
//                            color: "#444",
//                            fontSize: "12px",
//                          }}
//                        />
//                      )}
//                    </Box>
            
//                    {/* Title */}
//                    <Typography
//                       sx={{
//                        mt: 1,
//                        fontSize: "16px",
//                        fontWeight: 600,
//                        color: "#111827",
//                      }}
//                    >
//                      {option.title}
//                    </Typography>
            
//                     {/* Subtitle */}
//                     <Typography
//                       sx={{
//                         mt: 0.5,
//                         fontSize: "13px",
//                         color: "#374151",
//                         lineHeight: 1.4,
//                       }}
//                     >
//                       {option.subtitle}
//                    </Typography>
//                   </Box>
//                 </Card>
//             ))}
//           </Box>
//         )}

//         {/* Organization Management Cards Grid */}
//         {menudata === "Organization Management" && showOrgManagementCards && (
//           <Box
//             sx={{
//               display: "grid",
//               gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
//               gap: 3,
//               mt: 2,
//             }}
//           >
//             {organizationOptions.map((option) => (
//             <Card
//                   onClick={() => handleOrgManagementCardClick(option.key)}
//                   sx={{
//                     minWidth: { xs: 260, sm: 300 },
//                     borderRadius: "10px",
//                     border: "1px solid #e5e7eb",
//                     boxShadow:
//                       "0 10px 20px rgba(0,0,0,0.08)",
//                     cursor: "pointer",
//                     transition: "all 0.25s ease",
//                     "&:hover": {
//                       transform: "translateY(-4px)",
//                       boxShadow: "0 16px 30px rgba(0,0,0,0.12)",
//                     },
//                   }}
//                 >
//                   {/* Image Section */}
//                   <Box p={1.5}>
//                     <Box
//                       sx={{
//                         borderRadius: "8px",
//                         bgcolor: "#f5f5f5",
//                         overflow: "hidden",
//                         height: 180,
//                         display: "flex",
//                         alignItems: "center",
//                        justifyContent: "center",
//                       }}
//                     >
//                       <Box
//                         component="img"
//                         src={option.image}
//                         alt={title}
//                         sx={{
//                           width: "100%",
//                           height: "100%",
//                           objectFit: "contain",
//                         }}
//                      />
//                     </Box>
//                   </Box>
            
//                   {/* Content */}
//                   <Box px={1.5} pb={2}>
//                     {/* Badges */}
//                     <Box display="flex" gap={1} flexWrap="wrap">
//                       {option.badge && (
//                         <Chip
//                           label={option.badge}
//                           size="small"
//                           sx={{
//                             bgcolor: "#e11d48",
//                             color: "#fff",
//                             fontWeight: 600,
//                            fontSize: "12px",
//                          }}
//                        />
//                       )}
            
//                       {option.tag && (
//                         <Chip
//                          label={option.tag}
//                           size="small"
//                          sx={{
//                            bgcolor: "rgba(0,0,0,0.06)",
//                            color: "#444",
//                            fontSize: "12px",
//                          }}
//                        />
//                      )}
//                    </Box>
            
//                    {/* Title */}
//                    <Typography
//                       sx={{
//                        mt: 1,
//                        fontSize: "16px",
//                        fontWeight: 600,
//                        color: "#111827",
//                      }}
//                    >
//                      {option.title}
//                    </Typography>
            
//                     {/* Subtitle */}
//                     <Typography
//                       sx={{
//                         mt: 0.5,
//                         fontSize: "13px",
//                         color: "#374151",
//                         lineHeight: 1.4,
//                       }}
//                     >
//                       {option.subtitle}
//                    </Typography>
//                   </Box>
//                 </Card>
//             ))}
//           </Box>
//         )}

//         {/* Render Sub-page Components */}
//         {menudata === "Third Party Interviewers" && <TP_interviewermgmt />}
//         {selectedAdminMaster === "Area Management" && <SDCManagement />}
//         {selectedAdminMaster === "Department Management" && <DepartmentManagement />}
//         {selectedAdminMaster === "Sector Management" && <SectorManagement />}
//         {selectedAdminMaster === "Role Management" && <RoleManagement />}
//         {selectedAdminMaster === "Skill Management" && <SkillManagement />}

//         {menudata === "User Management" && <UserManagement />}
//         {menudata === "Page access rights" && <PageRightsAccess />}
//         {menudata === "UserSubscribers" && <UserSubscribers />}

//         {/* Organization Management Sub-pages */}
//         {!showOrgManagementCards && menudata === "Add Organization" && <AddOrganization />}
//         {menudata === "Subscribe Detail" && (
//           <SubscribeDetail onOpenSubscriptionPlan={handleOpenSubscriptionPlan} />
//         )}
//         {showSubscriptionPlan && <SubscriptionPlan />}
//         {!showOrgManagementCards && menudata === "List Organization" && (
//           <ListOrganization
//             onOpenAddOrganization={handleOpenAddOrganization}
//             onOpenEditOrganization={handleOpenEditOrganization}
//           />
//         )}
//         {showAddOrganization && <AddOrganization orgData={editOrgData} />}
//       </Box>
//     </Box>
//   );
// };

// export default AdminLandingPage;


















































import React, { useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Drawer as MuiDrawer,
  AppBar as MuiAppBar,
  Toolbar,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Tooltip,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Chip,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ChevronRight as ChevronRightIcon,
  ChevronLeft as ChevronLeftIcon,
  Home as HomeIcon,
  Settings as SettingsIcon,
  People as PeopleIcon,
  Business as BusinessIcon,
  VideoCall as VideoCallIcon,
  Logout as LogoutIcon,
  ExpandMore as ExpandMoreIcon,
  Fullscreen as FullscreenIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
// import COLORS from "../../Themes/Colours"
import { useThemeMode } from "../../Themes/ThemeContextTemp";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../Redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { CapitalizeName } from "../../../utils/capitalizeName";
import department from '../../../card icons/department.png'
import area from '../../../card icons/area.png'
import sector from '../../../card icons/sector.png'
import role from '../../../card icons/role.png'
import skill from '../../../card icons/skill.png'
import add from '../../../card icons/add.png'
import list from '../../../card icons/list.png'
// Components
import AdminDashboard from "../AdminDashboard";
import UserSubscribers from "../UserSubscribers";
import SubscribeDetail from "../SubscribeDetail";
import SubscriptionPlan from "../SubscriptionPlan";
import SectorManagement from "../SectorManagement";
import MockDash from "../AdminDashboard/MockDash";
import SDCManagement from "../SDCManagement";
import DepartmentManagement from "../DepartmentManagement";
import UserManagement from "../UserManagement";
import AddOrganization from "../AddOrganization";
import ListOrganization from "../ListOrganization";
import RoleManagement from "../RoleManagement";
import SkillManagement from "../SkillManagement";
import PageRightsAccess from "../PageRightAccess";
import TP_interviewermgmt from "../TP_Interviewer";


const drawerWidth = 300;

// ==================== STYLED COMPONENTS ====================
// NOTE: These styled components use theme from Material-UI, not COLORS
// COLORS is only available inside the component via useThemeMode hook

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

// SOLUTION 1: Move styled components inside component or use callbacks
// We'll use inline styles for components that need COLORS
// This way they have access to COLORS from the hook

const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      // COLORS.secondary will be applied via inline style
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      // COLORS.secondary will be applied via inline style
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  }),
}));

const StyledAppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  // COLORS.primary will be applied via inline style
  borderBottom: `1px solid ${theme.palette.divider}`,
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

// ==================== MAIN COMPONENT ====================
const AdminLandingPage = ({ title }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const [menudata, setMenudata] = useState("Dashboard");
  const [titleText, setTitleText] = useState("Admin Dashboard");
  const [open, setOpen] = useState(true);
  const [editOrgData, setEditOrgData] = useState(null);
  const [showAddOrganization, setShowAddOrganization] = useState(false);
  const [showSubscriptionPlan, setShowSubscriptionPlan] = useState(false);
  const [profileAnchor, setProfileAnchor] = useState(null);
  const [selectedAdminMaster, setSelectedAdminMaster] = useState(null);
  const [showOrgManagementCards, setShowOrgManagementCards] = useState(true);
  const { COLORS, theme, toggleTheme } = useThemeMode();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userName = CapitalizeName(user?.name || "");

  const ADMIN_MASTER_CONFIG = [
    {
      title: "Department Management",
      image: department,
      subtitle: "Organization Structure",
      key: "Department Management",
      badge: "Admin",
      tag: "Configuration",
    },
    {
      title: "Area Management",
      image: area,
      subtitle: "Geographical Areas",
      key: "Area Management",
      badge: "Admin",
      tag: "Location",
    },
    {
      title: "Sector Management",
      image: sector,
      subtitle: "Business Sectors",
      key: "Sector Management",
      badge: "Admin",
      tag: "Business",
    },
    {
      title: "Role Management",
      image: role,
      subtitle: "Access & Permissions",
      key: "Role Management",
      badge: "Admin",
      tag: "Access",

    },
    {
      title: "Skill Management",
      image: skill,
      subtitle: "Employee Skills",
      key: "Skill Management",
      badge: "Admin",
      tag: "HR",
    },
  ];

  const organizationOptions = [

    { title: "Add Organization",
      key: "Add Organization",
      image: add,
      subtitle: "Register New Organization",
      badge: "Organization",
      tag: "Client",

     },
    { title: "List Organization",
      key: "List Organization",
      image: list,
      subtitle: "View Organization",
      badge: "Organization",
      tag: "Client", },
  ];

  const menuItems = [
    {
      label: "Dashboard",
      icon: HomeIcon,
      key: "Dashboard",
    },
    {
      label: "Admin Master",
      icon: SettingsIcon,
      key: "Admin Master",
    },
    {
      label: "User Management",
      icon: PeopleIcon,
      key: "User Management",
    },
    {
      label: "Organization Management",
      icon: BusinessIcon,
      key: "Organization Management",
    },
    {
      label: "Third Party Interviewers",
      icon: PeopleIcon,
      key: "Third Party Interviewers",
    },
  ];

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleListItemClick = (item) => {
    setMenudata(item);
    setTitleText(item);
    setShowAddOrganization(false);
    setShowSubscriptionPlan(false);
    setSelectedAdminMaster(null);
    setShowOrgManagementCards(true);
  };

  // Handle Admin Master Card Click
  const handleAdminMasterCardClick = (masterKey, masterTitle) => {
    setSelectedAdminMaster(masterKey);
    setMenudata(masterKey);
    setTitleText(masterTitle);
  };

  // Handle back button for Admin Master
  const handleBackFromAdminMaster = () => {
    setSelectedAdminMaster(null);
    setMenudata("Admin Master");
    setTitleText("Admin Master");
  };

  // Handle Organization Management Card Click
  const handleOrgManagementCardClick = (option) => {
    setShowOrgManagementCards(false);
    setMenudata(option);
    setTitleText(option);
  };

  // Handle back button for Organization Management
  const handleBackFromOrgManagement = () => {
    setShowOrgManagementCards(true);
    setMenudata("Organization Management");
    setTitleText("Organization Management");
  };

  const handleOpenAddOrganization = () => {
    setMenudata("");
    setTitleText("Add Organization");
    setShowAddOrganization(true);
    setEditOrgData(null);
  };

  const handleOpenEditOrganization = (orgData) => {
    setMenudata("");
    setTitleText("Edit Organization");
    setShowAddOrganization(true);
    setEditOrgData(orgData);
  };

  const handleOpenSubscriptionPlan = () => {
    setMenudata("");
    setShowSubscriptionPlan(true);
  };

  const handleProfileMenuOpen = (event) => {
    setProfileAnchor(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileAnchor(null);
  };

  const handleLogOut = () => {
    handleProfileMenuClose();
    localStorage.clear();
    sessionStorage.clear();
    dispatch(logout());
    setTimeout(() => navigate("/"), 0);
  };

  if (!isAuthenticated || user?.role !== "Admin") {
    return null;
  }

  const handleFullscreen = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      const element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    }
  };

  return (
    <Box sx={{ display: "flex", background: COLORS.background, minHeight: "100vh" }}>
      {/* AppBar */}
      <StyledAppBar position="fixed" open={open} sx={{ background: COLORS.primary, borderBottom: `1px solid ${COLORS.border}` }}>
        <Toolbar sx={{ minHeight: "80px !important", display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton
              color="inherit"
              aria-label="toggle drawer"
              onClick={handleDrawerToggle}
              edge="start"
              sx={{ color: COLORS.accent }}
            >
              {open ? <ChevronLeftIcon /> : <MenuIcon />}
            </IconButton>

            {/* Back Button for Admin Master */}
            {selectedAdminMaster && (
              <IconButton
                onClick={handleBackFromAdminMaster}
                sx={{ color: COLORS.accent, mr: 1 }}
                title="Go back"
              >
                <ArrowBackIcon />
              </IconButton>
            )}

            {/* Back Button for Organization Management */}
            {menudata === "Organization Management" && !showOrgManagementCards && (
              <IconButton
                onClick={handleBackFromOrgManagement}
                sx={{ color: COLORS.accent, mr: 1 }}
                title="Go back"
              >
                <ArrowBackIcon />
              </IconButton>
            )}

            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                fontSize: "20px",
                fontWeight: 600,
                color: COLORS.text,
                letterSpacing: "0.5px",
              }}
            >
              {titleText}
            </Typography>
          </Box>

          {/* Right Side Actions */}
          <Stack direction="row" spacing={2} sx={{ display: "flex", alignItems: "center" }}>
            <Toolbar sx={{ justifyContent: "flex-end" }}>
              <IconButton
                onClick={toggleTheme}
                sx={{
                  color: COLORS.text,
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                {theme === "light" ? (
                  <DarkModeIcon />
                ) : (
                  <LightModeIcon />
                )}
              </IconButton>
            </Toolbar>

            <Tooltip title="Fullscreen Mode (F11)">
              <IconButton
                onClick={handleFullscreen}
                sx={{
                  color: COLORS.text,
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                <FullscreenIcon />
              </IconButton>
            </Tooltip>

            <Button
              onClick={handleProfileMenuOpen}
              sx={{
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                gap: 1,
                color: COLORS.text,
                textTransform: "none",
                fontSize: "14px",
                padding: "6px 12px",
                borderRadius: "6px",
                "&:hover": { background: COLORS.hoverBg },
              }}
            >
              <Avatar
                sx={{
                  width: 32,
                  height: 32,
                  background: COLORS.accent,
                  fontSize: "14px",
                  fontWeight: 700,
                }}
              >
                {userName.charAt(0).toUpperCase()}
              </Avatar>
              <Typography sx={{ fontSize: "13px" }}>{userName.split(" ")[0]}</Typography>
              <ExpandMoreIcon sx={{ fontSize: "18px" }} />
            </Button>

            {/* Profile Menu */}
            <Menu
              anchorEl={profileAnchor}
              open={Boolean(profileAnchor)}
              onClose={handleProfileMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                sx: {
                  background: COLORS.primary,
                  border: `1px solid ${COLORS.border}`,
                  borderRadius: "8px",
                  mt: 1,
                },
              }}
            >
              <MenuItem
                sx={{
                  color: COLORS.text,
                  padding: "12px 20px",
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                <Avatar
                  sx={{
                    width: 28,
                    height: 28,
                    background: COLORS.accent,
                    mr: 1.5,
                    fontSize: "12px",
                  }}
                >
                  {userName.charAt(0).toUpperCase()}
                </Avatar>
                {userName}
              </MenuItem>

              <MenuItem
                sx={{
                  color: COLORS.textSecondary,
                  fontSize: "12px",
                  padding: "4px 20px",
                  "&:hover": { background: "transparent" },
                }}
              >
                {user?.role}
              </MenuItem>

              <Divider sx={{ borderColor: COLORS.border, my: 1 }} />

              <MenuItem
                onClick={handleLogOut}
                sx={{
                  color: COLORS.accent,
                  padding: "12px 20px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  "&:hover": { background: COLORS.hoverBg },
                }}
              >
                <LogoutIcon sx={{ fontSize: "18px" }} />
                Logout
              </MenuItem>
            </Menu>
          </Stack>
        </Toolbar>
      </StyledAppBar>

      {/* Drawer */}
      <StyledDrawer 
        variant="permanent" 
        open={open}
        sx={{
          "& .MuiDrawer-paper": {
            background: COLORS.secondary,
            borderRight: `1px solid ${COLORS.border}`,
          },
        }}
      >
        <DrawerHeader sx={{ minHeight: "80px !important", borderBottom: `1px solid ${COLORS.border}` }}>
          {open && (
            <Box sx={{ pr: 2, width: "100%" }}>
              <Typography
                sx={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: COLORS.accent,
                  textTransform: "uppercase",
                  letterSpacing: "1.5px",
                  mb: 1,
                }}
              >
                Navigation
              </Typography>
            </Box>
          )}
        </DrawerHeader>

        {/* Navigation List */}
        <List sx={{ color: COLORS.text, flex: 1 }}>
          {menuItems.map((item) => (
            <ListItem key={item.key} disablePadding>
              <ListItemButton
                onClick={() => handleListItemClick(item.key)}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                  "&:hover": {
                    background: COLORS.hoverBg,
                    color: COLORS.accent,
                  },
                  color: menudata === item.key && !selectedAdminMaster && !showOrgManagementCards === false ? COLORS.accent : COLORS.text,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    color: "inherit",
                  }}
                >
                  <item.icon sx={{ fontSize: "22px" }} />
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  sx={{
                    opacity: open ? 1 : 0,
                    fontSize: "14px",
                    "& .MuiTypography-root": {
                      fontSize: "14px",
                      fontWeight: menudata === item.key && !selectedAdminMaster ? 600 : 500,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        {/* Bottom Divider */}
        <Divider sx={{ borderColor: COLORS.border }} />

        {/* Bottom Actions */}
        {open && (
          <Box
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Button
              onClick={handleLogOut}
              fullWidth
              sx={{
                color: COLORS.accent,
                display: "flex",
                alignItems: "center",
                gap: 1,
                justifyContent: "flex-start",
                textTransform: "none",
                fontSize: "14px",
                padding: "10px 12px",
                borderRadius: "6px",
                border: `1px solid ${COLORS.border}`,
                "&:hover": {
                  background: COLORS.hoverBg,
                  borderColor: COLORS.accent,
                },
              }}
            >
              <LogoutIcon sx={{ fontSize: "18px" }} />
              Logout
            </Button>
          </Box>
        )}
      </StyledDrawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
           p: 3,        // ← Keep padding for content sides
           pt: 1,
          minHeight: "100vh",
          background: COLORS.background,
          overflow: "auto",
        }}
      >
        {/* Dashboard */}
        {menudata === "Dashboard" && <MockDash />}

        {/* Admin Master Cards Grid */}
        {menudata === "Admin Master" && !selectedAdminMaster && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
              gap: 3,
              mt: 2,
            }}
          >
            {ADMIN_MASTER_CONFIG.map((option) => (
            
             <Card
                  onClick={() => handleAdminMasterCardClick(option.key, option.title)}
                  sx={{
                    minWidth: { xs: 260, sm: 300 },
                    borderRadius: "10px",
                    border: `1px solid ${COLORS.cardBorder}`,
                    background: COLORS.cardBg,
                    boxShadow:
                      "0 10px 20px rgba(0,0,0,0.08)",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 16px 30px rgba(0,0,0,0.12)",
                      borderColor: COLORS.accent,
                    },
                  }}
                >
                  {/* Image Section */}
                  <Box p={1.5}>
                    <Box
                      sx={{
                        borderRadius: "8px",
                        bgcolor: COLORS.card_img_bg || "#f5f5f5",
                        overflow: "hidden",
                        height: 180,
                        display: "flex",
                        alignItems: "center",
                       justifyContent: "center",
                      }}
                    >
                      <Box
                        component="img"
                        src={option.image}
                        alt={title}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                     />
                    </Box>
                  </Box>
            
                  {/* Content */}
                  <Box px={1.5} pb={2}>
                    {/* Badges */}
                    <Box display="flex" gap={1} flexWrap="wrap">
                      {option.badge && (
                        <Chip
                          label={option.badge}
                          size="small"
                          sx={{
                            bgcolor: COLORS.button_red_bg,
                            color: COLORS.background,
                            fontWeight: 600,
                           fontSize: "12px",
                         }}
                       />
                      )}
            
                      {option.tag && (
                        <Chip
                         label={option.tag}
                          size="small"
                         sx={{
                          //  bgcolor: "rgba(0,0,0,0.06)",
                           background:COLORS.card_chip_bg,
                           color:COLORS.card_txt_color,
                          //  color: "#444",
                           fontSize: "12px",
                         }}
                       />
                     )}
                   </Box>
            
                   {/* Title */}
                   <Typography
                      sx={{
                       mt: 1,
                       fontSize: "16px",
                       fontWeight: 600,
                       color: COLORS.text,
                     }}
                   >
                     {option.title}
                   </Typography>
            
                    {/* Subtitle */}
                    <Typography
                      sx={{
                        mt: 0.5,
                        fontSize: "13px",
                        color: COLORS.textSecondary || "#374151",
                        lineHeight: 1.4,
                      }}
                    >
                      {option.subtitle}
                   </Typography>
                  </Box>
                </Card>
            ))}
          </Box>
        )}

        {/* Organization Management Cards Grid */}
        {menudata === "Organization Management" && showOrgManagementCards && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
              gap: 3,
              mt: 2,
            }}
          >
            {organizationOptions.map((option) => (
            <Card
                  onClick={() => handleOrgManagementCardClick(option.key)}
                  sx={{
                    minWidth: { xs: 260, sm: 300 },
                    borderRadius: "10px",
                    border: `1px solid ${COLORS.cardBorder}`,
                    background: COLORS.cardBg,
                    boxShadow:
                      "0 10px 20px rgba(0,0,0,0.08)",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 16px 30px rgba(0,0,0,0.12)",
                      borderColor: COLORS.accent,
                    },
                  }}
                >
                  {/* Image Section */}
                  <Box p={1.5}>
                    <Box
                      sx={{
                        borderRadius: "8px",
                        bgcolor: COLORS.card_img_bg || "#f5f5f5",
                        overflow: "hidden",
                        height: 180,
                        display: "flex",
                        alignItems: "center",
                       justifyContent: "center",
                      }}
                    >
                      <Box
                        component="img"
                        src={option.image}
                        alt={title}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                     />
                    </Box>
                  </Box>
            
                  {/* Content */}
                  <Box px={1.5} pb={2}>
                    {/* Badges */}
                    <Box display="flex" gap={1} flexWrap="wrap">
                      {option.badge && (
                        <Chip
                          label={option.badge}
                          size="small"
                          sx={{
                            bgcolor: COLORS.button_red_bg,
                            color: COLORS.background,
                            fontWeight: 600,
                           fontSize: "12px",
                         }}
                       />
                      )}
            
                      {option.tag && (
                        <Chip
                         label={option.tag}
                          size="small"
                         sx={{
                           background:COLORS.card_chip_bg,
                           color:COLORS.card_txt_color,
                           fontSize: "12px",
                         }}
                       />
                     )}
                   </Box>
            
                   {/* Title */}
                   <Typography
                      sx={{
                       mt: 1,
                       fontSize: "16px",
                       fontWeight: 600,
                       color: COLORS.text,
                     }}
                   >
                     {option.title}
                   </Typography>
            
                    {/* Subtitle */}
                    <Typography
                      sx={{
                        mt: 0.5,
                        fontSize: "13px",
                        color: COLORS.textSecondary || "#374151",
                        lineHeight: 1.4,
                      }}
                    >
                      {option.subtitle}
                   </Typography>
                  </Box>
                </Card>
            ))}
          </Box>
        )}

        {/* Render Sub-page Components */}
        {menudata === "Third Party Interviewers" && <TP_interviewermgmt />}
        {selectedAdminMaster === "Area Management" && <SDCManagement />}
        {selectedAdminMaster === "Department Management" && <DepartmentManagement />}
        {selectedAdminMaster === "Sector Management" && <SectorManagement />}
        {selectedAdminMaster === "Role Management" && <RoleManagement />}
        {selectedAdminMaster === "Skill Management" && <SkillManagement />}

        {menudata === "User Management" && <UserManagement />}
        {menudata === "Page access rights" && <PageRightsAccess />}
        {menudata === "UserSubscribers" && <UserSubscribers />}

        {/* Organization Management Sub-pages */}
        {!showOrgManagementCards && menudata === "Add Organization" && <AddOrganization />}
        {menudata === "Subscribe Detail" && (
          <SubscribeDetail onOpenSubscriptionPlan={handleOpenSubscriptionPlan} />
        )}
        {showSubscriptionPlan && <SubscriptionPlan />}
        {!showOrgManagementCards && menudata === "List Organization" && (
          <ListOrganization
            onOpenAddOrganization={handleOpenAddOrganization}
            onOpenEditOrganization={handleOpenEditOrganization}
          />
        )}
        {showAddOrganization && <AddOrganization orgData={editOrgData} />}
      </Box>
    </Box>
  );
};

export default AdminLandingPage;